<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-management">
    <el-tabs v-model="activeTab" tab-position="left" @tab-click="tabClick">
      <el-tab-pane name="companyInfo" label="Company Info" v-if="false">
        <wy-management-company ref="managementInfo" />
      </el-tab-pane>
      <el-tab-pane name="ManageTeam" label="Manage Team">
        <wy-management-team ref="managementTeam" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import WyManagementCompany from './wy-management-company';
import WyManagementTeam from './wy-management-team';

export default {
  name: 'wy-management',
  modalTitle: 'Account',
  components: {
    'wy-management-company': WyManagementCompany,
    'wy-management-team': WyManagementTeam,
  },
  props: [],
  data() {
    return {
      controller: this,
      activeTab: 'ManageTeam',
    }
  },

  computed: {
    ...mapGetters(['user']),

  },

  methods: {
    
    tabClick() {
      if(this.activeTab == 'companyInfo') {
        // setTimeout(()=>{
        //   this.$refs.managementInfo.$refs.companyNameTxt.focus();
        // }, 500)
      }
      if(this.activeTab == 'ManageTeam') {
        setTimeout(()=>{
          if(this.$refs.managementTeam.$refs.addMemberBtn.$el) {
            this.$refs.managementTeam.$refs.addMemberBtn.$el.focus();
          }
        }, 500)
      }
    }
  }
};
</script>

<style lang="scss">
.wy-management {
  .el-tabs__active-bar.is-left{
    width: 6px !important;
  }
  height:100%;
  .el-tabs, .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll, .el-tabs__nav {
    height: 100%;    
  }
  .el-tabs__content {
    box-sizing: border-box;
    padding: 20px;
    height: 100%;
    // overflow-y: auto;
  }
  div#tab-companyInfo {
    color: var(--site-font-primary-color);
  }
  .pane-companyInfo {
    min-width: 1145px;
  }

  div#tab-ManageTeam {
    color: var(--site-font-primary-color);
  }
  #pane-ManageTeam {
    // min-width: 1145px;
    height: 100%;
  }

  .el-tabs__item.is-active {
    background-color: #E2ECF7;
  }

  .el-tabs__active-bar {
    background-color: #214586;
    width: 6px !important;
  }
}
</style>